import { render, staticRenderFns } from "./PlumaDispersionForm.vue?vue&type=template&id=325e190e&scoped=true"
import script from "./PlumaDispersionForm.vue?vue&type=script&lang=js"
export * from "./PlumaDispersionForm.vue?vue&type=script&lang=js"
import style0 from "./_geoproceso-forms.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PlumaDispersionForm.vue?vue&type=style&index=1&id=325e190e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e190e",
  null
  
)

export default component.exports